module.exports = __webpack_public_path__ + "static/media/move.b6798c8c.svg";